var _rect, _rect2, _circle, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModdable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 350,
    viewBox: "0 0 400 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 43,
    width: 280,
    height: 263,
    rx: 20,
    stroke: "#EA3377",
    strokeWidth: 20
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 80,
    width: 192,
    height: 163,
    rx: 5,
    stroke: "#EA3377",
    strokeWidth: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 299.86,
    cy: 272.86,
    r: 11.8599,
    fill: "#FF3131"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 101,
    width: 36,
    height: 122,
    fill: "#FF3131"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 101,
    width: 36,
    height: 122,
    fill: "#93E54B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 101,
    width: 36,
    height: 122,
    fill: "#68ADE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModdable);
export default __webpack_public_path__ + "static/media/moddable.773b1ad2e0fc1454a65ccebe5e73177b.svg";
export { ForwardRef as ReactComponent };